









































import { ItemCategory } from "@/graphql/client";
import { Component, Emit, Vue } from "vue-property-decorator";
import itemCategoryService from "@/service/itemCategoryService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class ItemCategoryEditDialog extends Vue {
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: ItemCategory = itemCategoryService.defaultItemCategory;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * ダイアログを表示します.
   */
  public open(item: ItemCategory): void {
    this.item = item;

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  deleteItem(): void {
    this.isProgressing = true;
    //delete
    itemCategoryService.deleteItemCategory(this.item).then((result) => {
      this.isProgressing = false;
      this.notifySuccess(result as ItemCategory);
    });
  }

  /**
   * 処理成功
   */
  @Emit("onSuccess")
  public notifySuccess(deleted: ItemCategory): ItemCategory {
    return deleted;
  }
}
